var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRemove2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85725 15.1117C0.858438 15.6123 1.03945 16.0921 1.36073 16.4461C1.682 16.8001 2.1174 16.9995 2.57175 17.0008H9.429C9.88335 16.9995 10.3187 16.8001 10.64 16.4461C10.9613 16.0921 11.1423 15.6123 11.1435 15.1117V3.7775H0.85725V15.1117ZM12 0.944582H9L8.14275 0H3.85725L3 0.944582H0V2.83375H12V0.944582Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemove2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/remove2.bac1a300.svg";
export { ForwardRef as ReactComponent };